import { useEffect, useRef, useState } from 'react';

import { UseWatchApplicationStatusParams } from '../types/UseWatchApplicationStatusParams';

export const useWatchApplicationStatus = ({
  enabled,
  pollInterval = 20_000,
  statusToLeave,
  fetchLatestApplication,
}: UseWatchApplicationStatusParams): boolean => {
  const [hasLeftStatus, setHasLeftStatus] = useState(false);

  const fetchLatestApplicationRef = useRef(fetchLatestApplication);

  useEffect(() => {
    fetchLatestApplicationRef.current = fetchLatestApplication;
  }, [fetchLatestApplication]);

  useEffect(() => {
    if (enabled) {
      setHasLeftStatus(false);
    }
  }, [enabled, statusToLeave]);

  useEffect(() => {
    if (!enabled || hasLeftStatus) {
      return;
    }

    let cancelled = false;
    let timer: number | null = null;

    const schedule = () => {
      timer = window.setTimeout(tick, pollInterval);
    };

    const tick = async () => {
      if (cancelled) {
        return;
      }

      const application = await fetchLatestApplicationRef.current();

      if (application && application.status !== statusToLeave) {
        setHasLeftStatus(true);

        return;
      }

      if (!cancelled) {
        schedule();
      }
    };

    tick();

    return () => {
      cancelled = true;

      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [enabled, pollInterval, statusToLeave, hasLeftStatus]);

  return hasLeftStatus;
};
